import React from "react";
import * as Animate from "react-reveal";

import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import OwlCarousel from "react-owl-carousel";
import { Link } from "react-router-dom";
import learningDataAfrica from "./data/learningDataAfrica";
import learningDataEurope from "./data/learningDataEurope";

const Card = ({ course }) => {
  return (
    <div className="bg-white w-72 bg-white2 card rounded-xl h-full">
      <Link to={course?.url} className="">
        <div className="card-header rounded-tl-xl rounded-tr-xl">
          <img src={course?.image} alt="" />
        </div>

        <div className="px-6 py-10 rounded-b-xl">
          <div className="mb-4 text-xs leading-5 flex flex-wrap space-x-2">
            <div className="tag-primary px-2 rounded-sm">
              <p>{course?.courseType}</p>
            </div>
            <div className="tag-secondary px-2 rounded-sm">
              <p>{course?.courseLevel}</p>
            </div>
          </div>
          <h3 className="xl:pr-4 font-mono font-semibold text-default text-lg lg:text-xl">
            {course?.title}
          </h3>
        </div>
      </Link>
    </div>
  );
};

const LearningSection = () => {
  return (
    // <section className="pt-20 lg:pt-24 pb-24 lg:pb-28 individual-learning-section">
    <section className="pt-16 pb-24 lg:pb-18 individual-learning-section">
      <div className="container mx-auto px-4">
        <div className="w-full lg:w-8/12 xl:w-6/12">
          <Animate.Fade bottom>
            <h2 className="text-primary text-3xl lg:text-4xl xl:text-5xl xl:leading-tight font-mono font-semibold">
              Experience Lifelong Learning with Utiva
            </h2>

            <p className="mt-6 text-sm-15 lg:text-base xl:text-lg lg:leading-7">
              Top courses people are learning
            </p>
          </Animate.Fade>
        </div>

        <div className="mt-6 lg:mt-10">
          <OwlCarousel
            className="owl-carousel owl-theme"
            items={4}
            loop={true}
            autoWidth={true}
            nav={false}
            dots={false}
            margin={28}
            stageClass="pt-5"
            responsiveClass={true}
            responsive={{
              0: {
                items: 1,
                nav: false,
              },
              600: {
                items: 3,
                nav: false,
              },
              1000: {
                items: 4,
                nav: false,
                loop: false,
              },
            }}
          >
            {learningDataAfrica?.map((datum) => (
              <Card key={datum?.id} course={datum} />
            ))}
          </OwlCarousel>
        </div>

        <div className="mt-6 lg:mt-10">
          <OwlCarousel
            className="owl-carousel owl-theme"
            items={4}
            loop={true}
            autoWidth={true}
            nav={false}
            dots={false}
            margin={28}
            stageClass="pt-5"
            responsiveClass={true}
            responsive={{
              0: {
                items: 1,
                nav: false,
              },
              600: {
                items: 3,
                nav: false,
              },
              1000: {
                items: 4,
                nav: false,
                loop: false,
              },
            }}
          >
            {learningDataEurope?.map((datum) => (
              <Card key={datum?.id} course={datum} />
            ))}
          </OwlCarousel>
        </div>
      </div>
    </section>
  );
};

export default LearningSection;
